import React, { useState, useEffect, useMemo, useContext } from 'react'
import * as classes from './Development.module.scss'
import cn from 'classnames'
import Container from '../../../ui/Container/Container'
import splitRow from '../../../../utils/splitRow'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'
import { FormContext } from '../../../../context'
import { useDataDevelopment } from './useDataDevelopment'
import { startAnimationScroll } from '../../../../utils/animations'
import { useDataDevelopmentByEn } from './useDataDevelopmentByEn'
import splitTitleV2 from '../../../../utils/splitTitleV2'

function Development({ lang }) {
    const dataByHy = useDataDevelopment()
    const dataByEn = useDataDevelopmentByEn()

    const data = lang === 'hy' ? dataByHy : dataByEn

    const { animationStart } = useContext(FormContext)

    const yearOne = useMemo(() => deleteHtmlTag(data.yearOne.value, 'p'), [])
    const textNumber = useMemo(() => deleteHtmlTag(data.textNumber.value, 'p'), [])

    const titleOne = useMemo(() => deleteHtmlTag(data.titleOne.value, 'p'), [])
    const titleTwo = useMemo(() => deleteHtmlTag(data.titleTwo.value, 'p'), [])

    const [contentTopAnime, setContentTopAnime] = useState({
        title: titleOne,
        text: data.textOne.value
    })

    const [contentBottomAnime, setContentBottomAnime] = useState({
        title: titleTwo,
        text: data.textTwo.value
    })

    const classAnimationTitle = 'anime-title-development'
    const classAnimationText = 'anime-text-development'

    useEffect(() => {
        if (animationStart) {
            splitRow(classAnimationText)
            splitTitleV2(classAnimationTitle)
        }

        const observer = startAnimationScroll([
            { type: 'title', className: classAnimationTitle },
            { type: 'text', className: classAnimationText }
        ])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [animationStart])

    return (
        <section className={cn(classes.Section, { [classes.LangHY]: lang === 'hy' })}>
            <Container>
                <div className={classes.Inner}>
                    {yearOne || contentTopAnime.title || contentTopAnime.text ? (
                        <div className={classes.Column}>
                            {yearOne ? (
                                <div className={classes.Mark}>
                                    <span className={classes.Dash} />
                                    <span className={classes.MarkText}>{lang === 'hy' ? `Սկսած ${yearOne}` : `Since ${yearOne}`}</span>
                                </div>
                            ) : null}

                            {contentTopAnime.title || contentTopAnime.text ? (
                                <div className={classes.Block} id='development-content-top'>
                                    {contentTopAnime.title ? (
                                        <h2
                                            className={`anime-scroll ${classAnimationTitle}`}
                                            dangerouslySetInnerHTML={{ __html: contentTopAnime.title }}
                                        />
                                    ) : null}

                                    {contentTopAnime.text ? (
                                        <div
                                            className={classes.Text + ' anime-scroll ' + classAnimationText}
                                            dangerouslySetInnerHTML={{ __html: contentTopAnime.text }}
                                        />
                                    ) : null}
                                </div>
                            ) : null}
                        </div>
                    ) : null}

                    {textNumber || contentBottomAnime.title || contentBottomAnime.text ? (
                        <div className={classes.Column}>
                            {textNumber ? (
                                <div className={classes.Mark}>
                                    <span className={classes.Dash} />
                                    <span className={classes.MarkText}>{lang === 'hy' ? textNumber : `+ ${textNumber}`}</span>
                                </div>
                            ) : null}

                            {contentBottomAnime.title || contentBottomAnime.text ? (
                                <div className={classes.Block} id='development-content-bottom'>
                                    {contentBottomAnime.title ? (
                                        <h2
                                            className={`anime-scroll ${classAnimationTitle}`}
                                            dangerouslySetInnerHTML={{ __html: contentBottomAnime.title }}
                                        />
                                    ) : null}

                                    {contentBottomAnime.text ? (
                                        <div
                                            className={classes.Text + ' anime-scroll ' + classAnimationText}
                                            dangerouslySetInnerHTML={{ __html: contentBottomAnime.text }}
                                        />
                                    ) : null}
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </Container>
        </section>
    )
}

export default Development
